export default __webpack_public_path__ + "static/media/ava-10.bc8a0938.png";